var _style, _defs, _path, _g, _g2, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon0, _polygon1, _polygon10, _defs2, _ellipse, _polygon11, _polygon12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 318.7 361",
    style: {
      enableBackground: "new 0 0 318.7 361"
    },
    xmlSpace: "preserve",
    className: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);fill:#33C999;}\n\t.st1{clip-path:url(#SVGID_2_);}\n\t.st2{fill:#282829;}\n\t.st3{fill:#F3D8C2;}\n\t.st4{fill:#CDA192;}\n\t.st5{enable-background:new    ;}\n\t.st6{fill:#D3D3D3;}\n\t.st7{fill:#898989;}\n\t.st8{fill:#A7A7A7;}\n\t.st9{fill:#22986B;}\n\t.st10{fill:#2EDB9C;}\n\t.st11{fill:url(#SVGID_3_);}\n\t.st12{fill:#F0F0F0;}\n\t.st13{fill:#00A271;}\n\t.st14{fill:#BFBFBF;}\n\t.st15{clip-path:url(#SVGID_5_);fill:#363636;}\n\t.st16{clip-path:url(#SVGID_5_);fill:#BFBFBF;}\n\t.st17{clip-path:url(#SVGID_5_);fill:#F0F0F0;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M151.6,336.4L151.6,336.4C67.9,336.4,0,268.5,0,184.8v0C0,101.1,67.9,33.2,151.6,33.2h0 c83.7,0,151.6,67.9,151.6,151.6v0C303.2,268.5,235.3,336.4,151.6,336.4z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M151.6,336.4L151.6,336.4C67.9,336.4,0,268.5,0,184.8v0C0,101.1,67.9,33.2,151.6,33.2h0 c83.7,0,151.6,67.9,151.6,151.6v0C303.2,268.5,235.3,336.4,151.6,336.4z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M56.3,134.3c0,0,37,13.4,50,6.9s14.5-19.4,14.5-19.4L56.3,27.9L56.3,134.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M154.1,294.8c-13.1,3.2-28.9-65-28.9-65s-31.3,18.6-47.8-56.9S59.9,37.5,59.9,37.5L97,29.8 C97,29.8,167.3,291.6,154.1,294.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M70.7,138.8c0,0,32.6-15.6,51.6-11l-1.5-6l-46.4-9.9l-8.1,5.3L70.7,138.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M77.9,120.7c20.3-3.2,42.9,1,42.9,1L98,22.8l-41.7,5.1l0,106.4C56.3,134.3,57.6,123.9,77.9,120.7z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "234.6,322.1 147.2,342.6 68.7,319.6 156.1,299.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "68.6,338.1 68.7,319.6 147.2,342.6 147.1,361  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "147.1,361 147.2,342.6 234.6,322.1 234.5,340.6  "
  })))), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M121.9,307.4v15.3c0,5.1,13.7,9.2,30.6,9.2c16.9,0,30.6-4.1,30.6-9.2v-15.3H121.9z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st10",
    cx: 152.5,
    cy: 307.4,
    rx: 30.6,
    ry: 9.2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 317.0093,
    y1: 244.683,
    x2: 317.0093,
    y2: 69.5225
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "315.4,70.5 318.7,69.5 318.6,243.7 315.3,244.7  "
  })), /*#__PURE__*/React.createElement("g", null, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "210.5,22.5 318.7,0 318.6,174.2 210.3,196.7  "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "216.9,31.5 312.3,11.7 312.2,19.6 216.8,39.5  "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "216.9,180.9 312.3,161.1 312.2,169 216.8,188.8  "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "216.9,144.1 312.3,124.3 312.2,126.8 216.8,146.7  "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "216.9,83.1 312.3,63.3 312.2,65.8 216.8,85.7  "
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "216.9,49 264.5,39.1 264.4,41.6 216.8,51.5  "
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "216.9,58 264.5,48.1 264.4,50.6 216.8,60.5  "
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "216.9,67 264.5,57.1 264.4,59.6 216.8,69.5  "
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "224,102.7 247.9,97.7 247.7,100.2 223.9,105.2  "
  })), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "224,111.7 247.9,106.7 247.7,109.2 223.9,114.2  "
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "224,120.7 247.9,115.7 247.7,118.2 223.9,123.2  "
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "SVGID_4_",
    transform: "matrix(0.1028 -0.9947 0.9947 0.1028 224.228 334.538)",
    cx: 297.6,
    cy: 43,
    rx: 12.5,
    ry: 9.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_5_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_4_",
    style: {
      overflow: "visible"
    }
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1028 -0.9947 0.9947 0.1028 224.228 334.538)",
    className: "st15",
    cx: 297.6,
    cy: 43,
    rx: 12.5,
    ry: 9.8
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "289.8,54.3 295.8,41.9 301.1,46.8 304.4,37 309.9,45.3 308,56.2 297.6,59.2  "
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "289.8,54.3 295.8,41.9 301.1,46.8 304.4,37 304.8,44.4 301.1,46.8 295.8,41.9 296.5,46.8  "
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewDocument);
export default __webpack_public_path__ + "static/media/new-document.0742dc9abc0befe11a4e9fc4484bf422.svg";
export { ForwardRef as ReactComponent };